
import { defineComponent, PropType } from "vue";
import { IImage, IJobFiled } from "@/types/Members.d";
import { ITerm } from "@/types/ITerm";
import { WpApiMembers } from "@/types/WpApi";

declare let wpApiMembers: WpApiMembers;

export default defineComponent({
  name: "Modal-View",
  emits: ["closeModal"],
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    showDetails: {
      type: Boolean,
      required: true,
    },
    showName: {
      type: Boolean,
      required: true,
    },
    image: {
      type: Object as PropType<IImage>,
      required: true,
    },
    title: {
      type: String,
    },
    jobFields: {
      type: Array as PropType<IJobFiled[]>,
    },
    phone: {
      type: String,
    },
    email: {
      type: String,
    },
    fieldsOfActivity: {
      type: Array as PropType<ITerm[]>,
    },
  },
  data() {
    return {
      translations: wpApiMembers.translations,
    };
  },
  methods: {
    translate(key: string) {
      return this.translations[key] ? this.translations[key] : key;
    },
    removeListener(el: HTMLDivElement) {
      if (el) {
        el.onclick = null;
        el.ontouchstart = null;
        el.ontouchmove = null;
        el.ontouchend = null;
      }
    },
    stopPropagation(event: TouchEvent | MouseEvent) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      this.$emit("closeModal");
    },
  },
  mounted() {
    this.removeListener(this.$refs["modal-container"] as HTMLDivElement);
    this.removeListener(this.$refs["modal-wrapper"] as HTMLDivElement);
  },
});
